export default function getProgressValue(totalSteps: number, completedSteps: number) {
	return (100 / totalSteps) * completedSteps;
}
